import React from 'react';
import {
    CardContent,
    Typography,
    Avatar,
    Box,
    useTheme,
    useMediaQuery
} from '@mui/material';

function MetricView({ data, title, icon }) {
    const theme = useTheme();
    const isLg = useMediaQuery(theme.breakpoints.up('lg'));

    const todayCount = data?.dailyCount?.[data.dailyCount.length - 1]?.count ?? null;
    const totalCount = data?.totalCount ?? null;

    return (
        <CardContent sx={{ width: '100%', p: 0, display: 'flex', justifyContent: 'center' }}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={3}
                flexShrink={0}
                sx={{
                    background: 'linear-gradient(135deg, rgba(25,118,210,0.1) 0%, rgba(25,118,210,0.05) 100%)',
                    borderRadius: 3,
                    p: isLg ? 3 : 2,
                    pr: isLg ? 5 : 4,
                    boxShadow: '0 2px 10px rgba(25,118,210,0.1)',
                    width: '100%',
                    maxWidth: 400,
                    minWidth: 260,
                    boxSizing: 'border-box'
                }}
            >
                <Avatar
                    sx={{
                        bgcolor: 'primary.main',
                        width: 68,
                        height: 68,
                        boxShadow: '0 4px 12px rgba(25,118,210,0.3)',
                        fontSize: 32,
                    }}
                >
                    {React.cloneElement(icon, { sx: { fontSize: 36 } })}
                </Avatar>

                <Box>
                    <Typography
                        variant="subtitle1"
                        color="primary.dark"
                        sx={{
                            textTransform: 'uppercase',
                            letterSpacing: 1,
                            mb: 1,
                            fontWeight: 500,
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            color: 'text.primary',
                            lineHeight: 1.2,
                        }}
                    >
                        {todayCount?.toLocaleString() ?? '--'}
                        <Typography
                            component="span"
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontWeight: 400, ml: 0.5 }}
                        >
                            today
                        </Typography>
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            mt: 0.5,
                            fontWeight: 600,
                            color: 'text.primary',
                        }}
                    >
                        {totalCount?.toLocaleString() ?? '--'}
                        <Typography
                            component="span"
                            variant="body2"
                            color="text.secondary"
                            sx={{ ml: 0.5 }}
                        >
                            in 30 days
                        </Typography>
                    </Typography>
                </Box>
            </Box>
        </CardContent>
    );
}

export default MetricView;
